import { AbstractDTO } from './abstract';

export class DictionaryTermDTO extends AbstractDTO {
	static ATTR_NAME = 'name';
	static ATTR_VALUE = 'value';

	name: number;
	value: string;

	constructor(attributes?: object) {
		super(attributes);
		attributes = attributes ? attributes : {};

		this.name = attributes['name'] || '';
		this.value = attributes['value'] || '';
	}
}
